var map = {
	"./de/config-table.png": "VheY",
	"./en/config-table.png": "IyeZ",
	"./es/config-table.png": "l6dm",
	"./fr/config-table.png": "6pW0",
	"./ja/config-table.png": "MpUk",
	"./ko/config-table.png": "TTOA",
	"./pt/config-table.png": "QqGr",
	"./ru/config-table.png": "zQYf",
	"./tc/config-table.png": "rHLL",
	"./th/config-table.png": "7bb2",
	"./zh-Hant/config-table.png": "KAN3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3k5b";